import styled from "styled-components";

const RegWrapper = styled.main`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  padding-block: 3rem;
`;

export default RegWrapper;
